'use client';

import AlgoliaSearch from 'components/commercetools-ui/organisms/product/product-list-algolia/components/Algolia-search-Page';
import React from 'react';

const AlgoliaSearchPageTastic = ({ data }: any) => {
  return (
    <div>
      <AlgoliaSearch badgeData={data} />
    </div>
  );
};

export default AlgoliaSearchPageTastic;
